
(function() {
  const lightbox = () => {
    const leftArrowSVGString = '<svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon--direction-aware" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square" stroke-width="2"></path></svg>';
    const closeSvgString = '<svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.2"></path></svg>';
    const lightbox = new PhotoSwipeLightbox({
      gallery: '.splide__gallery',
      // Only the chosen option's photos (M148, 2026-09-25). On a computer the gallery keeps every option's photos in
      // the page and hides the others with .hidden-by-filter (theme.js filterSlidesDesktopGrid). PhotoSwipe reads this
      // selector again at every click, so an option change needs nothing more. Phones rebuild their list: unchanged.
      children: '.splide__slide:not(.hidden-by-filter) .product-media-zoom',
      bgOpacity: 1,
      showHideAnimationType: 'zoom',
      loop: true,
      counter: true,
      zoom: false,
      bgClickAction: false,
      arrowPrevSVG: leftArrowSVGString,
      arrowNextSVG: leftArrowSVGString,
      closeSVG: closeSvgString,
      pswpModule: PhotoSwipe
    });
    lightbox.init();
    // THE STONE'S 360 JOINS THIS ZOOM (owner 2026-09-29): snippets/stone-spin.liquid adds the 360 as slide 1
    // through PhotoSwipe's public hooks. It needs this instance, which exists only in here, so it is handed
    // out and announced; a page without a 360 never reads it. Announced again after a theme-editor section
    // reload, which builds a new instance.
    window.SRLightbox = lightbox;
    document.dispatchEvent(new CustomEvent('sr:lightbox', {detail: {lightbox}}));
  }
  document.addEventListener("DOMContentLoaded", function() {
    lightbox();
    document.addEventListener('shopify:section:load', () => lightbox());
  });
})()

